<template>
  <div>
    <div class="card-body">

      <h5 class="card-title">{{ title }} <small class="text-muted" v-show="subTitle">{{ subTitle }}</small></h5>


      <div class="table-responsive" v-if="displayType === 'table'">
        <table class="table table-stripped table-sm table-hover">
          <thead>
            <tr>
              <th scope="col">SDN</th>
              <th scope="col">Objekt</th>
              <th scope="col">Zadeva</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr role="button" v-for="wo in entities">
              <td @click="selectOrderAsync(wo, true)" class="bg-light">{{ wo.orderNumber }}</td>
              <td @click="selectOrderAsync(wo)">{{ wo.facilityName }}</td>
              <td @click="selectOrderAsync(wo)">{{ wo.subject }}</td>
              <td>
                <button class="btn btn-primary btn-sm" v-if="wo.status === 'Active' && isAdmin" @click="openAssign(wo)">Dodeli</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else-if="displayType === 'card'">

      <ul>
        <li v-for="wo in entities" class="mt-1">
          <router-link :to="{ name: 'ServiceOrder', params: { workOrderId: wo.id } }" class="me-1">{{ wo.orderNumber }}</router-link>
          <button class="btn btn-primary btn-sm float-end" v-if="wo.status === 'Active' && isAdmin" @click="openAssign(wo)">Dodeli</button>
          <OrderBadge :workOrder="wo" />&nbsp;<strong>{{ wo.facilityName }}</strong>&nbsp;
          <br>
          <small class="text-muted">{{ wo.subject }}</small>
        </li>
      </ul>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { useAuth, isAdmin } from "../composition-api/useAuth"
import { listEntitiesAsync } from "../api"
import { useWorkOrders } from "scripts/composition-api/useWorkOrders"
import { assignmentsDone, openAssign } from "./AssignWorkOrder"

defineOptions({ name: "ServiceOrdersWithCompletedMovementsCard" })

defineProps({
    displayType: {
      type: String,
      default: "table",
    },
    title: {
      type: String,
      default: "Servisni nalogi v statusu Active s komisioni, ki so 100% dobavljeni",
    },
    subTitle: {
      type: String,
      default: "Zahtevani ali alternativni material",
    },
    itemsPerPage: {
      type: Number,
      default: 25,
    },
  })

const emit = defineEmits(["assigned"])

const router = VueRouter.useRouter()
const { fetchAuthAsync } = useAuth()
const { selectOrderAsync } = useWorkOrders("Service")

const entities = ref([])

const loadAsync = async () => {
  entities.value = await listEntitiesAsync(fetchAuthAsync, "ListServiceOrdersWithCompletedMaterialMovements")
}

onMounted(loadAsync)

// an assignment landed somewhere in the app - the owner shown in this list may be stale now
watch(assignmentsDone, async () => {
  await loadAsync()
  emit("assigned")
})
</script>
